import { styled } from "@mui/material";

export const StyledLabel = styled("span")(({ theme }) => theme.formComponents?.typography);
